import { searchRegistry } from "../../platform/search/register/search-registry";
import { PartyPopper} from "lucide-react";


searchRegistry.register([
    {
        id: "highlights.celebration",
        title: "Celebration",
        description: "View Upcoming celebrations",
        route: "/highlights/celebrations",
        category: "Administration",
        permissions: ["ADMIN","EMPLOYEE","USER"],
        tags: ["birthday", "work anniversary","celebration"],
        icon: PartyPopper,
        type: 'result'
    },
])
